module.exports = __webpack_public_path__ + "static/media/list.a5ea62a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/list.svg
// module id = ./src/assets/media/forum/list.svg
// module chunks = 16